import React from 'react';
import { makeStyles, Typography, Container, Grid } from '@material-ui/core';

import Image from '../assets/images/image-2.svg';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#f0f5f6',
    padding: theme.spacing(13, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6, 0),
    },
  },
  textContainer: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    '& > *': {
      marginBottom: theme.spacing(2),
    },
  },
  item1: {
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
  },
  item2: {
    [theme.breakpoints.down('sm')]: {
      order: 1,
    },
  },
  imageWrapper: {
    display: 'flex',
  },
  image: {
    marginLeft: 'auto',
    height: '100%',
  },
}));

export default function SectionD() {
  const classes = useStyles();

  return (
    <section id="about" className={classes.root}>
      <Container>
        <Grid container spacing={4}>
          <Grid container item xs={12} md={5} className={classes.item1}>
            <div className={classes.textContainer}>
              <Typography variant="h2">About Us</Typography>
              <Typography variant="h4">
                IntelliTrade was founded to provide trusted investment ideas in a simplified format to guide you on a
                successful investing path at an inexpensive cost. Many investors today are provided poor advice which
                leads to bad investment decisions, and coupled with improper risk controls, can quickly evaporate
                hard-earned money from your account. The team at IntelliTrade has decades of successful research and
                trading experience, and we want to bring the same experience and success to your investing accounts.
              </Typography>
              <Typography variant="h4">
                We are committed to offering true transparency in our trade recommendations and a promise to no front
                running trades.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={7} className={classes.item2}>
            <div className={classes.imageWrapper}>
              <Image className={classes.image} />
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}
